
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/accounts/reset-password",
      function () {
        return require("private-next-pages/accounts/reset-password/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/accounts/reset-password"])
      });
    }
  